import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const appEmbedConverter = {
  toPm: {
    types: [Node_Type.APP_EMBED],
    // @ts-ignore $TSFixMe
    convert: (node) => ({
      type: Node_Type.APP_EMBED,
      attrs: {
        ...node.appEmbedData,
        id: node.id
      }
    })
  },
  fromPm: {
    types: [Node_Type.APP_EMBED],
    convert: (node) => {
      const { id, ...data } = node.attrs || {};
      return {
        type: Node_Type.APP_EMBED,
        id,
        nodes: [],
        appEmbedData: {
          ...data
        }
      };
    }
  }
};
export {
  appEmbedConverter
};
//# sourceMappingURL=app-embed-converter.js.map
